import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategoryStrip() {
  return (
    <section className="border-y border-background-200 bg-background-100/50">
      <div className="mx-auto max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="从分类进入，快速定位想看的合集"
          desc="六大主题方向，每个方向下都收录了对应的专题目录与盘点内容。"
        />
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/topics?category=${cat.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${cat.icon} text-2xl`} />
              </span>
              <span className="flex-1">
                <span className="flex items-center justify-between">
                  <span className="font-heading text-base font-bold text-foreground-950">
                    {cat.name}
                  </span>
                  <i className="ri-arrow-right-up-line text-lg text-foreground-400 transition-colors group-hover:text-primary-600" />
                </span>
                <span className="mt-1 block text-sm leading-relaxed text-foreground-600">
                  {cat.desc}
                </span>
                <span className="mt-3 inline-block text-xs text-secondary-700">
                  已收录 {cat.count} 条合集
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}